<template>
    <b-modal id="modal_form"
             ref="modal_form"
             :title="modal_titulo"
             :ok-title="modal_botao"
             close-title="Fechar"
             size="lg"
             :ok-disabled=form.errors.any()
             v-model="showModal"
             @ok="handleOk">
        <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
            <b-row no-gutters>
                <b-col>
                    <label>Código</label>
                    <b-form-input type="text"
                                  placeholder="Código"
                                  v-model="form.cd"
                                  name="cd"
                                  >
                    </b-form-input>
                    <b-form-feedback v-text="form.errors.get('cd')" v-if="form.errors.has('cd')"></b-form-feedback>
                </b-col>
                <b-col>
                    <label>Descrição</label>
                    <b-form-input type="text"
                                  placeholder="Descrição"
                                  v-model="form.descr"
                                  name="descr"
                                  >
                    </b-form-input>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('descr')" v-if="form.errors.has('descr')"></b-form-feedback>
                </b-col>
                <b-col>
                    <label>Embalagem Instruções</label>
                    <b-form-input type="text"
                                  placeholder="Embalagem Instruções"
                                  v-model="form.embalagem_instrucoes"
                                  name="embalagem_instrucoes"
                                  >
                    </b-form-input>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('embalagem_instrucoes')" v-if="form.errors.has('embalagem_instrucoes')"></b-form-feedback>
                </b-col>
                <b-col>
                    <label>Embalagem Provisões</label>
                    <b-form-input type="text"
                                  placeholder="Embalagem Provisões"
                                  v-model="form.embalagem_provisoes"
                                  name="embalagem_provisoes"
                                  >
                    </b-form-input>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('embalagem_provisoes')" v-if="form.errors.has('embalagem_provisoes')"></b-form-feedback>
                </b-col>
                <b-col>
                    <label>Grupo Embalagem</label>
                    <b-form-input type="text"
                                  placeholder="Grupo Embalagem"
                                  v-model="form.grupo_embalagem"
                                  name="grupo_embalagem"
                                  >
                    </b-form-input>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('grupo_embalagem')" v-if="form.errors.has('grupo_embalagem')"></b-form-feedback>
                </b-col>
                <b-col>
                    <label>Número Risco</label>
                    <b-form-input type="text"
                                  placeholder="Número Risco"
                                  v-model="form.numero_risco"
                                  name="numero_risco"
                                  >
                    </b-form-input>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('numero_risco')" v-if="form.errors.has('numero_risco')"></b-form-feedback>
                </b-col>
                <b-col>
                    <label>Provisões Especiais</label>
                    <b-form-input type="text"
                                  placeholder="Provisões Especiais"
                                  v-model="form.provisoes_especiais"
                                  name="provisoes_especiais"
                                  >
                    </b-form-input>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('provisoes_especiais')" v-if="form.errors.has('provisoes_especiais')"></b-form-feedback>
                </b-col>
            </b-row>
            <b-row no-gutters>
                <b-col>
                    <label>Qtde. limite embalagem</label>
                    <b-form-input type="text"
                                  placeholder="Quantidade limite embalagem"
                                  v-model="form.quantidade_limite_embalagem_in"
                                  name="quantidade_limite_embalagem_in"
                                  >
                    </b-form-input>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('quantidade_limite_embalagem_in')" v-if="form.errors.has('quantidade_limite_embalagem_in')"></b-form-feedback>
                </b-col>
                <b-col>
                    <label>Qtde. limite veículo</label>
                    <b-form-input type="text"
                                  placeholder="Quantidade limite veículo"
                                  v-model="form.quantidade_limite_veiculo_kg"
                                  name="quantidade_limite_veiculo_kg"
                                  >
                    </b-form-input>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('quantidade_limite_veiculo_kg')" v-if="form.errors.has('quantidade_limite_veiculo_kg')"></b-form-feedback>
                </b-col>
                <b-col>
                    <label>Risco Subsidiário</label>
                    <b-form-input type="text"
                                  placeholder="Risco Subsidiário"
                                  v-model="form.risco_subsidiario"
                                  name="risco_subsidiario"
                                  >
                    </b-form-input>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('risco_subsidiario')" v-if="form.errors.has('risco_subsidiario')"></b-form-feedback>
                </b-col>
                <b-col>
                    <label>Tanque Instruções</label>
                    <b-form-input type="text"
                                  placeholder="Tanque Instruções"
                                  v-model="form.tanque_instrucoes"
                                  name="tanque_instrucoes"
                                  >
                    </b-form-input>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('tanque_instrucoes')" v-if="form.errors.has('tanque_instrucoes')"></b-form-feedback>
                </b-col>
                <b-col>
                    <label>Tanque Provisões</label>
                    <b-form-input type="text"
                                  placeholder="Tanque Provisões"
                                  v-model="form.tanque_provisoes"
                                  name="tanque_provisoes"
                                  >
                    </b-form-input>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('tanque_provisoes')" v-if="form.errors.has('tanque_provisoes')"></b-form-feedback>
                </b-col>
                <b-col>
                    <label>Classificação de Risco</label>
                    <multiselect v-model="classeRiscoSelected"
                    :options="optionsClasseRisco"
                    track-by="value"
                    label="label"
                    :hide-selected="true"
                    placeholder="Selecione"
                    tag-placeholder="Selecionar"
                    select-label="Selecionar"
                    selected-label="Selecionado"
                    deselect-label="Remover"
                    ></multiselect>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('clarisco_id')" v-if="form.errors.has('clarisco_id')"></b-form-feedback>
                </b-col>
                <b-col>
                    <label>Status</label>
                    <b-form-group>
                      <b-form-radio-group
                        v-model="form.status"
                        :options="optionsLivStatus"
                        name="status"
                        stacked
                        plain
                      ></b-form-radio-group>
                    </b-form-group>
                    <b-form-feedback v-text="form.errors.get('status')"  v-if="form.errors.has('status')"></b-form-feedback>
                </b-col>
            </b-row>
        </form>

        <div slot="modal-footer" class="w-100">
               <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
               <div class="float-right">
                   <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
                   <b-btn @click="showModal=false" variant="secondary">
                     Fechar
                   </b-btn>
                   <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                     Enviar
                   </b-btn>
               </div>
        </div>
    </b-modal>

</template>
<script>
import AvisoErros from '../components/AvisoErros'

export default {
components: {
    AvisoErros,
},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
      dataExport: [],
      modal_titulo: '',
      modal_botao: '',
      modal_acao: '',
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      classeRiscoSelected: [],
      optionsLivStatus: [],
      optionsClasseRisco: [],
      errors_array: [],
      form: new Form({
          cd: '',
          descr: '',
          embalagem_instrucoes: '',
          embalagem_provisoes: '',
          grupo_embalagem: '',
          numero_risco: '',
          provisoes_especiais: '',
          quantidade_limite_veiculo_kg: '',
          quantidade_limite_embalagem_in: '',
          risco_subsidiario: '',
          tanque_instrucoes: '',
          tanque_provisoes: '',
          clarisco_id: '',
          onu_id: '',
          status: ''
      }),

     helpForm: new Form({statusRecord: [], params: []}),
    fields: [
    {
        name: '__checkbox',
        titleClass: 'center aligned',
        dataClass: 'center aligned'
    },
    {
        name: 'cd',
        title: 'Código',
        sortField: 'cd'
    },
    {
        name: 'descr',
        title: 'Descrição',
        sortField: 'descr'
    },
    {
        name: 'numero_risco',
        title: 'Número risco',
        sortField: 'numero_risco'
    },
    {
        name: 'provisoes_especiais',
        title: 'Provisões Especiais',
        sortField: 'provisoes_especiais'
    },
    {
        name: 'risco_subsidiario',
        title: 'Risco Subsidiário',
        sortField: 'risco_subsidiario'
    },
    {
        name: 'classe_risco.cd',
        title: 'Classificação de Risco',
        sortField: 'classe_risco.cd'
    },
    {
        name: '__slot:status',
        title: 'Status',
        sortField: 'status'
    },
    {
        name: '__slot:actions',
        title: 'Ações',
        titleClass: 'center aligned',
        dataClass: 'center aligned'
    }

  ],
  css: {
      loadingClass: 'loading',
      ascendingIcon: 'glyphicon glyphicon-chevron-up',
      descendingIcon: 'glyphicon glyphicon-chevron-down',
      handleIcon: 'glyphicon glyphicon-menu-hamburger',
  },
  moreParams: {}
   }
},
watch: {
    classeRiscoSelected(obj) {
        this.form.clarisco_id = obj.value;
    }
},
mounted() {
    this.getLivGeral();
},
methods: {
    handleOk(e)
    {
        e.preventDefault();
        if(this.modal_acao=="i")
        {
           this.onStore();
        }
        else
        {
            this.onUpdate(this.form.onu_id);
        }
    },
    onCreate ()
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.form.reset();
      this.errors_array = '';
      this.errors_array = [];
      this.form.status = 1;
      this.$refs.modal_form.show();
    },
    onEdit (data, index, id)
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.errors_array = '';
      this.errors_array = [];
      this.form.cd = data.cd;
      this.form.descr = data.descr;
      this.form.embalagem_instrucoes = data.embalagem_instrucoes;
      this.form.embalagem_provisoes = data.embalagem_provisoes;
      this.form.grupo_embalagem = data.grupo_embalagem;
      this.form.numero_risco = data.numero_risco;
      this.form.provisoes_especiais = data.provisoes_especiais;
      this.form.quantidade_limite_veiculo_kg = data.quantidade_limite_veiculo_kg;
      this.form.quantidade_limite_embalagem_in = data.quantidade_limite_embalagem_in;
      this.form.risco_subsidiario = data.risco_subsidiario;
      this.form.tanque_instrucoes = data.tanque_instrucoes;
      this.form.tanque_provisoes = data.tanque_provisoes;
      this.classeRiscoSelected = { label: data.classe_risco.cd, value: data.classe_risco.clarisco_id };
      this.form.status = data.status.valor;
      this.form.onu_id = id;
      this.$refs.modal_form.show();
    },
    onStore()
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.put('/api/'+this.rota+'/store').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onUpdate(id)
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.patch('/api/'+this.rota+'/update/'+id).then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onActivateDesactivate(helpForm)
    {
        helpForm.patch('/api/'+this.rota+'/status').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });

    },
    getLivGeral()
    {
        this.helpForm.get('/api/onu/jsonlistgeral').then(response =>
        {
            new ReturnApi(response, this, true, false, false);
            response.status.forEach((obj)=>
            {
                this.optionsLivStatus.push({ text: obj.descr, value: obj.valor })
            })
            response.classe_risco.forEach((obj)=>
            {
                this.optionsClasseRisco.push({ label: obj.cd, value: obj.clarisco_id })
            })
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        return this.getPermissionFw(checkPermission);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    }
}
}
</script>
